<ng-container *transloco="let tloco; prefix: 'subscriptions.billing'">
  @if (!hidePageHeader) {
    <rma-page-header [title]="tloco('title')" />
  }
  <div class="container-padding">
    @if (subscription$ | async; as subscription) {
      @if (profile$ | async; as profile) {
        <rma-billing-info-nav
          class="mb-6"
          [subscription]="subscription"
          [profileName]="profile.fullName"
          [agencyName]="profile.parentName"
          [agentCount]="(agentCount$ | async) ?? 0"
          [showBillingLink]="false"
        />
      }
    } @else {
      @if (error$ | async; as error) {
        <mat-error>{{ 'form.error.generic-server-error' | transloco: { error: error } }}</mat-error>
      } @else {
        <mat-spinner />
      }
    }
    <div>
      <mat-card class="mb-6 p-4 md:p-6 lg:p-10">
        <div class="max-w-2xl">
          <h2 class="text-heading-2">{{ tloco('information') }}</h2>

          @if (isOverdue$ | async) {
            <rma-callout theme="caution">
              <div [innerHtml]="tloco('overdue-payment')"></div>
            </rma-callout>
          }

          @if (subscription$ | async; as subscription) {
            @if (subscriptionChanges$ | async; as subscriptionChanges) {
              <div
                class="mt-3 rounded bg-blue-10 p-3 leading-normal"
                [innerHtml]="
                  tloco(subscriptionChanges, {
                    oldPlan: subscription.name,
                    newPlan: subscription.newPlan,
                    date: subscription.subscriptionEnd | date: 'MMMM d y',
                  })
                "
              ></div>
            }
          }

          @if (upcomingInvoice$ | async; as upcomingInvoice) {
            @if (expiredPaymentMethod$ | async) {
              <div class="mt-3 flex gap-2 rounded bg-warning-10 p-3">
                <rma-icon class="text-warning-50" glyph="info" />
                <span>{{
                  tloco('card-expired', {
                    date: upcomingInvoice.dateDue | date: 'MMMM d y',
                    price: upcomingInvoice.amountDue | prettyCurrency,
                  })
                }}</span>
              </div>
            } @else {
              <div class="mt-3 flex gap-2 rounded bg-blue-10 p-3 leading-normal">
                <rma-icon glyph="info" theme="primary" />
                <span
                  [innerHtml]="
                    tloco('next-invoice', {
                      amountDue: upcomingInvoice.amountDue | prettyCurrency,
                      date: upcomingInvoice.dateDue | date: 'MMMM d y',
                    })
                  "
                ></span>
              </div>
            }
            @if (noPaymentMethods$ | async) {
              <div class="mt-3 flex gap-2 rounded bg-warning-10 p-3">
                <rma-icon class="text-warning-50" glyph="info" />
                <span>{{
                  tloco('upcoming-invoice-no-payment', {
                    date: upcomingInvoice.dateDue | date: 'MMMM d y',
                    price: upcomingInvoice.amountDue | prettyCurrency,
                  })
                }}</span>
              </div>
            }
          } @else {
            @if (noInvoice) {
              <div class="mt-3 rounded bg-steel-10 p-3">
                {{ tloco('no-invoice') }}
              </div>
            } @else {
              @if (error$ | async; as error) {
                <mat-error>{{ 'form.error.generic-server-error' | transloco: { error: error } }}</mat-error>
              } @else {
                <mat-spinner />
              }
            }
          }

          @if (isAgency$ | async) {
            <rma-billing-contact-details class="mt-5" />
          }

          @if (coupon$ | async; as coupon) {
            <div class="mt-5">
              <div class="mb-3 text-button">{{ tloco('active-discount') }}</div>
              <div [innerHtml]="tloco('coupon-applied', coupon)"></div>
            </div>
          }

          <rma-payment-methods class="mt-5" [paymentMethods]="paymentMethods$ | async" (refresh)="refresh()" />
        </div>
      </mat-card>

      <mat-card class="p-4 md:p-6 lg:p-10">
        <rma-invoices />
      </mat-card>
    </div>
  </div>
</ng-container>
